import type { FunctionComponent } from "react";

import { config } from "scmp-app/data/configs";

import { Container, StyledBaseLink, Text } from "./styles";

type Props = {
  className?: string;
};

export const PrintArticlePaywall: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <Text>Print option is available for subscribers only.</Text>

    <StyledBaseLink pathname={`${config.rosetta.subscribeHost}`}>SUBSCRIBE NOW</StyledBaseLink>
  </Container>
);

PrintArticlePaywall.displayName = "PrintArticlePaywall";
